<template>
  <CardContent>
  <fieldset
    v-if="storeApplicationType === 'new'"
    :id="'step' + formStore.currentStep + 'Fieldset'"
    class="Card-content u-padNone u-spaceItems2"
  >  
      <legend>
        <h2 class="u-textItalic u-textGrow2 Groove u-padBottom04">
          <span>Group/Legal Entity Information</span>
        </h2>
      </legend>
      <p>Please provide the following information about the group or legal entity.</p>
      <div></div>
      <!-- Group Information-->
      <fieldset class="u-spaceItems2">
        <legend>
          <h3>Group Information</h3>
        </legend>
        <div>
          <BaseInput
            id="groupName"
            name="groupName"
            label="Group Name"
            v-model="formStore.membershipApplicationInfo.groupLegalEntityInfo.groupName"
            :minlength="2"
            help-text="Enter the full legal name of the group or entity."
            required
          />
        </div>
        <div>
          <BaseInput
            id="groupTIN"
            name="groupTIN"
            label="Group Taxpayer Identification Number (TIN)"
            v-model="formStore.membershipApplicationInfo.groupLegalEntityInfo.groupTIN"
            placeholder="xx-xxxxxxx"
            :pattern="`[0-9]{2}-[0-9]{7}`"
            mask="##-#######"
            help-text="Format: 12-3456789"
            required
          />
        </div>
        <div>
          <RadioButtonGroup
            v-model="formStore.membershipApplicationInfo.groupLegalEntityInfo.groupMSO"
            name="groupMso"
            id="groupMso"
            :options="[
              { id: 'groupMsoYes', label: 'Yes', value: 'true', selected: true },
              { id: 'groupMsoNo', label: 'No', value: 'false' },
            ]"
            group-label=" Are you using a TIN that belongs to a Management Service Organization (MSO)?"
            required
          />
        </div>
      </fieldset>
      <hr/>
    <!-- Group Location-->
      <fieldset class="u-spaceItems2">
        <legend>
          <h3>Group Location</h3>
        </legend>
        <div class="Grid Grid--withGap">
          <div class="Grid-cell u-sm-size1of2">
            <BaseInput
              v-model="
                formStore.membershipApplicationInfo.groupLegalEntityInfo.fullAddress.address1
              "
              id="groupAddress1"
              name="groupAddress1"
              label="Street Address"
              required="required"
              maxlength="60"
              minlength="2"
            />
          </div>
          <div class="Grid-cell u-sm-size1of2">
            <BaseInput
              v-model="
                formStore.membershipApplicationInfo.groupLegalEntityInfo.fullAddress.address2
              "
              id="groupAddress2"
              name="groupAddress2"
              label="Street Address Line 2"
              help-text="Apartment, suite, unit, building, floor, etc."
              maxlength="20"
              minlength="2"
            />
          </div>
          <div class="Grid-cell u-sm-size1of3">
            <BaseInput
              v-model="formStore.membershipApplicationInfo.groupLegalEntityInfo.fullAddress.city"
              id="groupCity"
              name="groupCity"
              label="City"
              required="required"
              maxlength="30"
              minlength="2"
            />
          </div>
          <div class="Grid-cell u-sm-size1of3">
            <BaseSelect
              v-model="formStore.membershipApplicationInfo.groupLegalEntityInfo.fullAddress.state"
              id="groupState"
              name="groupState"
              label="State"
              required="required"
              :options="states"
              option-value="code"
              option-label="name"
              placeholder="Select a state"
            />
          </div>
          <div class="Grid-cell u-sm-size1of3">
            <BaseInput
              v-model="formStore.membershipApplicationInfo.groupLegalEntityInfo.fullAddress.zip"
              id="groupZip"
              name="groupZip"
              label="Zip Code"
              required="required"
              minlength="5"
              :pattern="`[0-9]{5}`"
              mask="#####"
              help-text="Format: 12345"
            />
          </div>
        </div>
      </fieldset>
    <hr/>
    <!-- Group Point of Contact -->
      <fieldset class="u-spaceItems2">
        <legend>
          <h3>Group Point of Contact</h3>
        </legend>
        <div class="Grid Grid--withGap">
          <div class="Grid-cell u-sm-size1of2">
            <BaseInput
              v-model="
                formStore.membershipApplicationInfo.groupLegalEntityInfo.pointOfContact
                  .groupPocFirstName
              "
              id="groupContactFirstName"
              name="groupContactFirstName"
              label="First Name"
              required="required"
            />
          </div>
          <div class="Grid-cell u-sm-size1of2">
            <BaseInput
              v-model="
                formStore.membershipApplicationInfo.groupLegalEntityInfo.pointOfContact
                  .groupPocLastName
              "
              id="groupContactLastName"
              name="groupContactLastName"
              label="Last Name"
              required="required"
            />
          </div>
          <div class="Grid-cell u-sm-size3of5">
            <BaseInput
              v-model="
                formStore.membershipApplicationInfo.groupLegalEntityInfo.pointOfContact
                  .groupPocPhone
              "
              id="groupContactPhone"
              name="groupContactPhone"
              label="Phone Number"
              type="tel"
              placeholder="123-456-7890"
              mask="###-###-####"
              required="required"
            />
          </div>
          <div class="Grid-cell u-sm-size2of5">
            <BaseInput
              v-model="
                formStore.membershipApplicationInfo.groupLegalEntityInfo.pointOfContact.groupPocExt
              "
              id="grouppContactExt"
              name="grouppContactExt"
              label="Extension"
              pattern="[0-9]"
            />
          </div>
          <div class="Grid-cell">
            <BaseInput
              v-model="
                formStore.membershipApplicationInfo.groupLegalEntityInfo.pointOfContact
                  .groupPocEmail
              "
              id="groupContactEmail"
              name="groupContactEmail"
              label="Email Address"
              type="email"
              placeholder="example@example.com"
              required="required"
            />
          </div>
        </div>
      </fieldset>
    <hr/>
    <!-- Group Contract Approval -->
    
      <!-- Person Information -->
      <fieldset class="u-spaceItems2">
        <legend>
          <h3>Group Contract Approval</h3>
        </legend>
        <fieldset class="u-spaceItems2">
          <legend>
            <h4>Contract Approval Contact Information</h4>
          </legend>
        </fieldset>
        <div class="Grid Grid--withGap">
          <div class="Grid-cell u-sm-size1of2">
            <BaseInput
              v-model="
                formStore.membershipApplicationInfo.groupLegalEntityInfo.contractApproval
                  .groupCapFirstName
              "
              id="groupCapFirstName"
              name="groupCapFirstName"
              label="First Name"
              required="required"
            />
          </div>
          <div class="Grid-cell u-sm-size1of2">
            <BaseInput
              v-model="
                formStore.membershipApplicationInfo.groupLegalEntityInfo.contractApproval
                  .groupCapLastName
              "
              id="groupCapLastName"
              name="groupCapLastName"
              label="Last Name"
              required="required"
            />
          </div>
          <div class="Grid-cell u-sm-size3of5">
            <BaseInput
              v-model="
                formStore.membershipApplicationInfo.groupLegalEntityInfo.contractApproval
                  .groupCapPhone
              "
              id="groupCapPhone"
              name="groupCapPhone"
              label="Phone Number"
              type="tel"
              placeholder="123-456-7890"
              mask="###-###-####"
              required="required"
            />
          </div>
          <div class="Grid-cell u-sm-size2of5">
            <BaseInput
              v-model="
                formStore.membershipApplicationInfo.groupLegalEntityInfo.contractApproval
                  .groupCapExt
              "
              id="groupCapExt"
              name="groupCapExt"
              label="Extension"
              pattern="[0-9]"
            />
          </div>
          <div class="Grid-cell">
            <BaseInput
              v-model="
                formStore.membershipApplicationInfo.groupLegalEntityInfo.contractApproval
                  .groupCapEmail
              "
              id="groupCapEmail"
              name="groupCapEmail"
              label="Email Address"
              type="email"
              placeholder="example@example.com"
              required="required"
            />
          </div>
        </div>
      </fieldset>
      <!-- Location Information -->
      <fieldset class="u-spaceTop6 u-spaceItems2">
        <legend>
          <h4>Contract Approval Address</h4>
        </legend>
        <div class="Grid Grid--withGap">
          <div class="Grid-cell u-sm-size1of2">
            <BaseInput
              v-model="
                formStore.membershipApplicationInfo.groupLegalEntityInfo.contractApproval
                  .groupCapAddress.address1
              "
              id="groupCapAddress1"
              name="groupCapAddress1"
              label="Street Address"
              required="required"
            />
          </div>
          <div class="Grid-cell u-sm-size1of2">
            <BaseInput
              v-model="
                formStore.membershipApplicationInfo.groupLegalEntityInfo.contractApproval
                  .groupCapAddress.address2
              "
              id="groupCapAddress2"
              name="groupCapAddress2"
              label="Street Address Line 2"
              help-text="Apartment, suite, unit, building, floor, etc."
            />
          </div>
          <div class="Grid-cell u-sm-size1of3">
            <BaseInput
              v-model="
                formStore.membershipApplicationInfo.groupLegalEntityInfo.contractApproval
                  .groupCapAddress.city
              "
              id="groupCapCity"
              name="groupCapCity"
              label="City"
              required="required"
            />
          </div>
          <div class="Grid-cell u-sm-size1of3">
            <BaseSelect
              v-model="
                formStore.membershipApplicationInfo.groupLegalEntityInfo.contractApproval
                  .groupCapAddress.state
              "
              id="groupCapState"
              name="groupCapState"
              label="State"
              required="required"
              :options="states"
              option-value="code"
              option-label="name"
              placeholder="Select a state"
            />
          </div>
          <div class="Grid-cell u-sm-size1of3">
            <BaseInput
              v-model="
                formStore.membershipApplicationInfo.groupLegalEntityInfo.contractApproval
                  .groupCapAddress.zip
              "
              id="groupCapZip"
              name="groupCapZip"
              label="Zip Code"
              required="required"
              minlength="5"
              :pattern="`[0-9]{5}`"
              mask="#####"
              help-text="Format: 12345"
            />
          </div>
        </div>
      </fieldset>
    <hr/>
    <!-- Physician Champion -->
      <fieldset class="u-spaceItems2">
        <legend>
          <h3>Group Physician Champion</h3>
        </legend>
        <p class="u-textShrink1">
          The Group Physician Champion can either be the same as your primary point of contact or a
          separate individual, depending on your preference.
        </p>
        <div class="checkbox-container">
          <label for="sameAsContact" class="Toggle Toggle--checkbox">
            <input
              class="Toggle-input"
              id="sameAsContact"
              v-model="formStore.championSameAsContact"
              type="checkbox"
            />
            <span class="Toggle-indicator"></span>
            <span>Is the Physician Champion the same as the Group Primary Contact?</span>
          </label>
        </div>
        <div class="Grid Grid--withGap">
          <div class="Grid-cell u-sm-size1of2">
            <BaseInput
              v-model="
                formStore.membershipApplicationInfo.groupLegalEntityInfo.physicianChampion
                  .championFirstName
              "
              id="championFirstName"
              name="championFirstName"
              label="First Name"
              required="required"
              :disabled="formStore.championSameAsContact"
            />
          </div>
          <div class="Grid-cell u-sm-size1of2">
            <BaseInput
              v-model="
                formStore.membershipApplicationInfo.groupLegalEntityInfo.physicianChampion
                  .championLastName
              "
              id="championLastName"
              name="championLastName"
              label="Last Name"
              required="required"
              :disabled="formStore.championSameAsContact"
            />
          </div>
          <div class="Grid-cell u-sm-size3of5">
            <BaseInput
              v-model="
                formStore.membershipApplicationInfo.groupLegalEntityInfo.physicianChampion
                  .championPhone
              "
              id="championPhone"
              name="championPhone"
              label="Phone Number"
              type="tel"
              placeholder="123-456-7890"
              mask="###-###-####"
              required="required"
              :disabled="formStore.championSameAsContact"
            />
          </div>
          <div class="Grid-cell u-sm-size2of5">
            <BaseInput
              v-model="
                formStore.membershipApplicationInfo.groupLegalEntityInfo.physicianChampion
                  .championExt
              "
              id="championExt"
              name="championExt"
              label="Extension"
              pattern="[0-9]"
              :disabled="formStore.championSameAsContact"
            />
          </div>
          <div class="Grid-cell">
            <BaseInput
              v-model="
                formStore.membershipApplicationInfo.groupLegalEntityInfo.physicianChampion
                  .championEmail
              "
              id="championEmail"
              name="championEmail"
              label="Email Address"
              type="email"
              placeholder="example@example.com"
              required="required"
              :disabled="formStore.championSameAsContact"
            />
          </div>
        </div>
      </fieldset>
  </fieldset>
  <fieldset
    v-else
    :id="'step' + formStore.currentStep + 'Fieldset'"
    class="Card-content u-padNone u-spaceItems2"
  >
    <CardContent>
      <legend>
        <h2 class="u-textItalic u-textGrow2 Groove u-padBottom04">
          <span>Group/Legal Entity Lookup</span>
        </h2>
      </legend>
      <p>
        Verify the group to which you are adding information by entering a valid
        <abbr title="Group Taxpayer Identification Number">TIN</abbr> below.
      </p>
      <!-- Group TIN Search Component -->
      <GroupTinSearchComponent
        @validity-changed="handleTinSearchValidityChange"
        @group-selected="handleGroupSelection"
      />
    </CardContent>
  </fieldset>
  </CardContent>
</template>

<script setup>
import { ref, watch, computed } from 'vue'
import { storeToRefs } from 'pinia'

import { useFormStore } from '../../stores/formStore'
import states from '../../data/states.json'

import BaseInput from '../fields/BaseInput.vue'
import RadioButtonGroup from '../fields/RadioButtonGroup.vue'
import CardContent from '../CardContent.vue'
import BaseSelect from '../fields/BaseSelect.vue'
import GroupTinSearchComponent from '../fields/GroupTinSearchComponent.vue'

const formStore = useFormStore()

// Extract reactive references from the store
const { applicationType: storeApplicationType } = storeToRefs(formStore)

// Handle physician champion sync functionality
const handleChampionSync = () => {
  if (formStore.championSameAsContact) {
    // Copy contact info to champion
    const contact = formStore.membershipApplicationInfo.groupLegalEntityInfo.pointOfContact
    const champion = formStore.membershipApplicationInfo.groupLegalEntityInfo.physicianChampion

    champion.championFirstName = contact.groupPocFirstName
    champion.championLastName = contact.groupPocLastName
    champion.championPhone = contact.groupPocPhone
    champion.championExt = contact.groupPocExt
    champion.championEmail = contact.groupPocEmail
  }
}

// Props from the parent form
defineProps({
  validator: {
    type: Object,
    required: false, // It may not be available immediately
  },
})

// Track TIN search validation state
const tinSearchValid = ref(false)

// Emit event to notify parent of validity change
const emit = defineEmits(['validity-changed'])

// Handlers for GroupTinSearchComponent events
const handleTinSearchValidityChange = (isValid) => {
  tinSearchValid.value = isValid
}

const handleGroupSelection = (selectedGroup) => {
  // Handle the selected group data
  // This will be called when a group is selected from search results
  formStore.tinSearchResults.selectedGroup = selectedGroup
}

// Watch for champion checkbox changes and sync data
watch(
  () => formStore.championSameAsContact,
  (isChecked) => {
    if (isChecked) {
      handleChampionSync()
    }
  },
  { immediate: true },
)

// Simple step validation
const isStep2Valid = computed(() => {
  if (formStore.applicationType === 'new') {
    // Validate required group info fields
    const group = formStore.membershipApplicationInfo.groupLegalEntityInfo
    return (
      group.groupName &&
      group.groupTIN &&
      group.fullAddress.address1 &&
      group.fullAddress.city &&
      group.fullAddress.state &&
      group.fullAddress.zip &&
      group.pointOfContact.groupPocFirstName &&
      group.pointOfContact.groupPocLastName &&
      group.pointOfContact.groupPocPhone &&
      group.pointOfContact.groupPocEmail &&
      group.contractApproval.groupCapFirstName &&
      group.contractApproval.groupCapLastName &&
      group.contractApproval.groupCapPhone &&
      group.contractApproval.groupCapEmail &&
      group.physicianChampion.championFirstName &&
      group.physicianChampion.championLastName &&
      group.physicianChampion.championPhone &&
      group.physicianChampion.championEmail
    )
  }
  // For 'add' applications, just need TIN search to be valid
  return tinSearchValid.value
})

// Watch for step validation changes
watch(
  isStep2Valid,
  (newValid) => {
    formStore.setStepValidation(2, newValid)
    emit('validity-changed', newValid)
  },
  { immediate: true },
)
</script>

<style scoped>
hr {
  height: 1px;
}
</style>
